import Header from "../../components/Header/Header";
import styles from "./Mind.module.css";
import Footer from "../../components/Footer/Footer";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import TabbedCarousel from "../../components/TabbedCarousel/TabbedCarousel";
import { useRef } from "react";
import { ourApproach } from "../../data/verticals";
import ColorBanner from "../../components/ColorBanner/ColorBanner";
import ArrowSubtitle from "../../components/ArrowSubtitle/ArrowSubtitle";
import TabbedAccordion from "../../components/TabbedAccordion/TabbedAccordion";
import WhiteTextSection from "../../components/WhiteTextSection/WhiteTextSection";
// import HorizontalScrollSection from "../../components/HorizontalScrollSection/HorizontalScrollSection";
import ToolCard from "../../components/ToolCard/ToolCard";
import NumberedGridList from "../../components/NumberedGridList/NumberedGridList";
import { ourFeatures } from "../../data/lists";
import { mindFAQ } from "../../data/faq";
import ArrowAccordion from "../../components/ArrowAccordion/ArrowAccordion";
import Carousel from "../../components/Carousel/Carousel";
import { mindTestimonials } from "../../data/testimonials";
import { Link } from "react-router-dom";
import usePageTitle from "../../hooks/usePageTitle";
import { useEffect } from "react";
import NumberStat from "../../components/NumberStat/NumberStat";

function Mind() {
    const videoContainerRef = useRef(null);
    const videoRef = useRef(null);
    const whoWeAreRef = useRef(null);
    const faqRef = useRef(null);

    usePageTitle("Mind");

    useEffect(() => {
        if (window.location.pathname.includes("/faq")) {
            faqRef.current.scrollIntoView({ behavior: "smooth" });
        }
    });

    function handleVideoCoverClick() {
        videoContainerRef.current.classList.remove(styles.show_cover);
        videoRef.current.play();
    }

    return (
        <div id={styles.mind}>
            <Header
                // logoSrcLight="/images/keel-mind-logo-white.svg"
                showSignIn={true}
                // backgroundScrollThreshold={0}
            />
            <main>
                <div id={styles.hero}>
                    <div id={styles.hero_card}>
                        <ArrowSubtitle text={"Welcome to Keel Mind"} />
                        <div id={styles.hero_card_top}>
                            <h1 className="main-h1">
                                The evolution of mental health care
                            </h1>
                        </div>
                        <div id={styles.hero_subtitle}>
                            <div>
                                We’re an AI-driven platform that facilitates
                                behavioral health training and education while
                                delivering measurement-based care.
                            </div>
                        </div>
                        <Link
                            id={styles.hero_learn_more}
                            // onClick={handleLearnMoreClick}
                            className="orange-button"
                            to={"/contact-us"}
                        >
                            Request a Demo
                            <img
                                src="/images/small-right-arrow-white.svg"
                                alt=""
                            />
                        </Link>

                        <div
                            id={styles.hero_video_container}
                            ref={videoContainerRef}
                            className={styles.show_cover}
                        >
                            <video
                                ref={videoRef}
                                id={styles.hero_video}
                                controls={true}
                                src="/videos/keel-mind-hero-video.mp4"
                            ></video>
                            <div
                                onClick={handleVideoCoverClick}
                                id={styles.hero_video_cover}
                            >
                                <video
                                    src="/videos/keel-mind-slideshow.mp4"
                                    autoPlay={true}
                                    playsInline={true}
                                    loop={true}
                                    muted={true}
                                    id={styles.hero_video_image_cover}
                                ></video>
                                {/* <img
                                    alt="A freeze frame of Ahad Bandealy, Chief Digital Officer of Keel Digital Solutions, standing in front of a man and a woman facing each other in lounge chairs."
                                    src="/images/keel-mind-hero-video-thumbnail.png"
                                    id={styles.hero_video_image_cover}
                                /> */}
                                <div id={styles.hero_video_color_cover}></div>
                                <button
                                    onClick={handleVideoCoverClick}
                                    id={styles.hero_video_play_button}
                                >
                                    <img
                                        draggable={false}
                                        src="/images/keel-mind-hero-video-play-icon.png"
                                        alt=""
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <WhiteTextSection
                    reference={whoWeAreRef}
                    arrowText={"Who we are"}
                >
                    We’re a <span>revolutionary online platform</span> that
                    provides more efficient training and monitoring for
                    educators, plus a suite of powerful decision support tools
                    combined with time-saving automated functions.
                </WhiteTextSection>
                <div id={styles.mind_content}>
                    <section
                        id={styles.our_approach}
                        data-scroll="our-approach"
                    >
                        <SectionHeading
                            arrowText={"Our approach"}
                            darkArrowSubtitle={true}
                            heading={
                                "Keel Mind is a business to government and government-agency company"
                            }
                        >
                            Four key verticals:
                        </SectionHeading>
                        <TabbedCarousel
                            data={ourApproach}
                            className={"small-hide"}
                        />
                        <TabbedAccordion
                            data={ourApproach}
                            className={"small-show"}
                        />
                    </section>
                    <section id={styles.our_tools} data-scroll="our-tools">
                        <SectionHeading
                            mainStyle={{
                                marginBottom: 0,
                                paddingBottom: 80,
                                maxWidth: 900,
                            }}
                            arrowText={"Our tools"}
                            heading={
                                "Innovative AI solutions to support every mental health journey"
                            }
                            darkArrowSubtitle={true}
                        />
                        <div id={styles.tool_cards_container}>
                            <ToolCard
                                iconSrc={
                                    "/images/tools/self-assessment-icon.png"
                                }
                                iconAlt={
                                    "icon of a man holding a phone, standing beside a large laptop, with a piece of paper containing a list leaning against the laptop screen."
                                }
                                name={"Self Assessment"}
                                description={
                                    "Tools that allow our clients to gain quick insights into their overall mental health and decide when it’s the right time to seek help."
                                }
                            />

                            <ToolCard
                                iconSrc={"/images/tools/keel-reels-icon.png"}
                                iconAlt={
                                    "icon of a man sitting in front of a laptop, holding a hand up, with a message speech bubble above his hand."
                                }
                                name={"Keel Reels"}
                                description={
                                    "An AI-driven chatbot interview that improves rapport between care providers and clients based on story-telling and lived experience."
                                }
                            />

                            <ToolCard
                                iconSrc={
                                    "/images/tools/natural-language-processing-icon.png"
                                }
                                iconAlt={""}
                                name={"Natural Language Processing"}
                                description={
                                    "Private and virtual video sessions, AI decision support tools, and analytics provides an expansive toolbox to increase care provider productivity."
                                }
                            />

                            <ToolCard
                                iconSrc={
                                    "/images/tools/automated-notes-icon.png"
                                }
                                iconAlt={
                                    "icon of a 3D line graph and circle graph showing sample data, with an avatar of a person and a message icon."
                                }
                                name={"Automated Notes & Tasks"}
                                description={
                                    "Formats session transcripts into editable notes, saving time and enabling providers to focus on care while improving oversight for supervisors."
                                }
                            />
                        </div>
                    </section>
                    <section
                        id={styles.our_features}
                        data-scroll="our-features"
                    >
                        <SectionHeading
                            arrowText={"Our features"}
                            darkArrowSubtitle={true}
                            heading={
                                "What makes the Keel Mind platform uniquely different"
                            }
                        />

                        <NumberedGridList data={ourFeatures} />
                    </section>

                    <section
                        id={styles.our_evidence}
                        data-scroll="our-evidence"
                    >
                        <div
                            className="big-dark-card"
                            id={styles.evidence_card}
                        >
                            <SectionHeading
                                arrowText={"Our evidence"}
                                heading={"Data-driven, high-quality care"}
                                headingStyle={{
                                    color: "white",
                                }}
                                textStyle={{ color: "white" }}
                            />
                            <div className={styles.evidence_container}>
                                <div className={styles.evidence}>
                                    <NumberStat
                                        value={83}
                                        suffix={"%"}
                                        className={styles.evidence_number}
                                    />
                                    <div>
                                        Feel an improvement in their
                                        <br />
                                        mental health & wellness.
                                    </div>
                                </div>
                                <div className={styles.evidence}>
                                    <NumberStat
                                        value={85}
                                        suffix={"k+"}
                                        className={styles.evidence_number}
                                    />
                                    <div>
                                        Clients helped using
                                        <br />
                                        our solutions
                                    </div>
                                </div>
                                <div className={styles.evidence}>
                                    <NumberStat
                                        value={90}
                                        suffix={"%"}
                                        className={styles.evidence_number}
                                    />
                                    <div>
                                        Feel the platform is
                                        <br />
                                        easy to access and use.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section
                        id={styles.testimonials_section}
                        className={styles.full}
                        data-scroll="our-impact"
                    >
                        <Carousel
                            heading={
                                "Delivering meaningful & effective results"
                            }
                            arrowText={"Our impact"}
                            darkArrowSubtitle={true}
                            data={mindTestimonials}
                        />
                    </section>
                    <section
                        id={styles.faq_section}
                        className={styles.full}
                        ref={faqRef}
                    >
                        <SectionHeading
                            arrowText={"FAQ"}
                            darkArrowSubtitle={true}
                            heading={"Answers to common questions"}
                        />
                        <ArrowAccordion data={mindFAQ} />
                    </section>
                </div>
                <ColorBanner />
            </main>
            <Footer />
        </div>
    );
}

export default Mind;
